export default __webpack_public_path__ + "static/media/pantry1-afterC-1440w.9534d7e3.png";